import { useParams, useSearchParams, Navigate } from 'react-router-dom';
import { StudyModeContent } from './StudyMode';

export default function StudySession() {
  const { id } = useParams<{ id: string }>();
  const [searchParams, setSearchParams] = useSearchParams();

  if (!id || isNaN(Number(id))) {
    return <Navigate to="/study" replace />;
  }

  return (
    <StudyModeContent
      searchParams={searchParams}
      setSearchParams={setSearchParams}
      sessionId={Number(id)}
    />
  );
}
